import React from "react";

import IconBase, { IconBaseProps } from "./IconBase";

/**
 * Others — 20×20 lab group icon (Figma 835:63).
 * Single layer 16.667 × 11.667, inset 20.83% top/bottom & 8.33% left/right.
 */
const IconOthers: React.FC<IconBaseProps> = ({
  size = 24,
  color = "currentColor",
  className = "",
  ...props
}) => {
  const iconSize =
    typeof size === "number" ? size : parseInt(size as string, 10) || 24;
  return (
    <IconBase
      size={iconSize}
      color={color}
      className={className}
      viewBox="0 0 20 20"
      {...props}
    >
      <g transform="translate(1.666 4.166)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.25 0C11.0199 0 10.8333 0.186542 10.8333 0.416667C10.8333 0.646792 11.0199 0.833333 11.25 0.833333V3.75H10V0.833333C10.2301 0.833333 10.4167 0.646792 10.4167 0.416667C10.4167 0.186542 10.2301 0 10 0H6.66667C6.43654 0 6.25 0.186542 6.25 0.416667C6.25 0.646792 6.43654 0.833333 6.66667 0.833333V3.75H5.41667V0.833333C5.64679 0.833333 5.83333 0.646792 5.83333 0.416667C5.83333 0.186542 5.64679 0 5.41667 0H2.08333C1.85322 0 1.66667 0.186542 1.66667 0.416667C1.66667 0.646792 1.85322 0.833333 2.08333 0.833333V3.75H1.25V2.5H0.416667V3.75H0V4.58333H0.416667V10H0V10.8333H0.416667V11.6667H1.25V10.8333H15.4167V11.6667H16.25V10.8333H16.6667V10H16.25V4.58333H16.6667V3.75H16.25V2.5H15.4167V3.75H14.5833V0.833333C14.8135 0.833333 15 0.646792 15 0.416667C15 0.186542 14.8135 0 14.5833 0H11.25ZM13.75 3.75V0.833333H12.0833V3.75H13.75ZM12.0833 4.58333H13.75V6.66667H12.0833V4.58333ZM11.25 4.58333V7.91667C11.25 8.83713 11.9962 9.58333 12.9167 9.58333C13.8371 9.58333 14.5833 8.83713 14.5833 7.91667V4.58333H15.4167V10H1.25V4.58333H2.08333V7.91667C2.08333 8.83713 2.82954 9.58333 3.75 9.58333C4.67046 9.58333 5.41667 8.83713 5.41667 7.91667V4.58333H6.66667V7.91667C6.66667 8.83713 7.41287 9.58333 8.33333 9.58333C9.25379 9.58333 10 8.83713 10 7.91667V4.58333H11.25ZM9.16667 3.75V0.833333H7.5V3.75H9.16667ZM4.58333 3.75V0.833333H2.91667V3.75H4.58333ZM2.91667 4.58333H4.58333V5.41667H2.91667V4.58333Z"
        />
      </g>
    </IconBase>
  );
};

export default IconOthers;
